export default __webpack_public_path__ + "static/media/iab-benefit-quality.6869328f.svg";